package com.essntl.features.category.ui.allcategories

import com.essntl.features.category.domain.model.CategoryModel

sealed interface AllCategoriesNavigation {
    data object AddCategory : AllCategoriesNavigation
    data class EditCategory(val category: CategoryModel) : AllCategoriesNavigation
}